<template>
  <div id="Users">
    <MyBanner
      :text="$t('banner.accessDcPage')"
      v-if="$t('banner.accessDcPage') != ''"
    />
    <MyHeaderPage
      :title="$t('reports.voip.title')"
      :subtitle="$t('reports.voip.subTitle')"
    />
    <br /><br />
    <div id="TicketsList">
      <div class="listTicket">
        <!-- FILTRO -->
        <div class="mdl-grid">
          <div
            class="mdl-cell"
            :class="[
              Object.entries(bills).length > 0
                ? 'mdl-cell--3-col mdl-cell--12-col-phone'
                : 'mdl-cell--6-col mdl-cell--12-col-phone',
            ]"
          >
            <div class="filterTickets" style="margin-top: 20px">
              <div class="contentInputFilter">
                <div class="contentIcon">
                  <span class="material-icons">search</span>
                </div>
                <div class="contentInput">
                  <input
                    type="text"
                    :placeholder="$t('actions.text_search_placeholder')"
                    v-model="searchString"
                    @keyup="searchByString"
                  />
                </div>
              </div>
            </div>
          </div>
          <div class="mdl-cell mdl-cell--3-col mdl-cell--12-col-phone">
            <div class="cdl-input" style="margin-top: 20px">
              <input
                type="date"
                name="dateFrom"
                class="not-empty"
                v-model="dateFrom"
                style="background-color: white"
                @change="getList()"
              />
              <label>{{ $t("reports.filter.dateFrom") }}</label>
              <span
                class="error"
                v-if="this.v$.dateFrom.$invalid && this.v$.dateFrom.$dirty"
              >
                {{ $t("reports.filter.dateFrom") }}
                {{ $t("reports.filter.isRequired") }}
              </span>
            </div>
          </div>
          <div class="mdl-cell mdl-cell--3-col mdl-cell--12-col-phone">
            <div class="cdl-input" style="margin-top: 20px">
              <input
                type="date"
                name="dateTo"
                class="not-empty"
                v-model="dateTo"
                style="background-color: white"
                @change="getList()"
              />
              <label>{{ $t("reports.filter.dateTo") }}</label>
              <span
                class="error"
                v-if="this.v$.dateTo.$invalid && this.v$.dateTo.$dirty"
              >
                {{ $t("reports.filter.dateTo") }}
                {{ $t("reports.filter.isRequired") }}
              </span>
            </div>
          </div>

          <div
            class="mdl-cell mdl-cell--3-col"
            v-if="Object.entries(bills).length > 0"
          >
            <div class="contentSelect">
              <span class="labelOne">{{ $t("reports.voip.bill") }}</span>
              <select
                name="datacenter"
                id="selectedUser"
                class="align"
                v-model="bill_id"
                @change="getList()"
                style="margin: 0; background-color: white"
              >
                <option :value="k" v-for="(bill, k) in bills" :key="k">
                  {{ bill }}
                </option>
              </select>
            </div>
          </div>
        </div>
        <!-- FINE FILTRO -->
        <div class="mdl-grid">
          <div
            class="mdl-cell mdl-cell--2-col mdl-cell--10-offset"
            v-if="itemFilter.length > 0"
          >
            <download-csv
              :data="voipCsv"
              :name="'Report VoIP ' + dateFrom + ' - ' + dateTo"
              :delimiter="';'"
              :labels="{
                from_call: $t('reports.voip.col.colOne'),
                to_call: $t('reports.voip.col.colTwo'),
                time_call: $t('reports.voip.col.colThree'),
                price_call: $t('reports.voip.col.colFour'),
                price_inc: $t('reports.voip.col.colFive'),
                data_call: $t('reports.voip.col.colSix'),
                destination: $t('reports.voip.col.colSeven'),
              }"
            >
              <button class="cdlButton">
                <img src="@/assets/img/download.png" alt="icon" />
                {{ $t("users.downLoadCSV") }}
              </button>
            </download-csv>
          </div>
          <div class="mdl-cell mdl-cell--12-col">
            <br />
            <ReportTable
              :items="itemFilter"
              :loading="viewLoader"
              :empty-colspan="$IsMobile() ? 1 : 7"
            >
              <template #header>
                <tr>
                  <th>{{ $t("reports.voip.col.colOne") }}</th>
                  <th>{{ $t("reports.voip.col.colTwo") }}</th>
                  <th v-if="!$IsMobile()">
                    {{ $t("reports.voip.col.colThree") }}
                  </th>
                  <th v-if="!$IsMobile()">
                    {{ $t("reports.voip.col.colFour") }}
                  </th>
                  <th v-if="!$IsMobile()">
                    {{ $t("reports.voip.col.colFive") }}
                  </th>
                  <th v-if="!$IsMobile()">
                    {{ $t("reports.voip.col.colSix") }}
                  </th>
                  <th v-if="!$IsMobile()">
                    {{ $t("reports.voip.col.colSeven") }}
                  </th>
                </tr>
              </template>

              <template #row="{ item, index }">
                <tr :class="{ odd: index % 2 }">
                  <td>{{ item.from_call }}</td>
                  <td>{{ item.to_call }}</td>
                  <td v-if="!$IsMobile()">{{ item.time_call }}</td>
                  <td v-if="!$IsMobile()">{{ item.price_call }}</td>
                  <td v-if="!$IsMobile()">{{ item.price_inc }}</td>
                  <td v-if="!$IsMobile()">{{ getDate(item.data_call) }}</td>
                  <td v-if="!$IsMobile()">{{ item.destination }}</td>
                </tr>
              </template>

              <template #mobile="{ item, index }">
                <MobileRow
                  :key="item.id || index"
                  :cols="['from_call', 'to_call']"
                  :item="item"
                ></MobileRow>
              </template>
            </ReportTable>
            <!--            <div>-->
            <!--              <MyLoading :viewLoader="this.viewLoader" type="" />-->
            <!--            </div>-->
            <Paginator
              v-if="viewLoader && totalItems > 0"
              :total-page="paginatedItems"
              :current-page="currentPage"
              :itemsPerPage="itemsPerPage"
              @prev-page="beforePage"
              @next-page="nextPage"
              @change-page="changePage"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import MyBanner from "@/components/MyBanner.vue";
import MyHeaderPage from "@/components/MyHeaderPage.vue";
import MobileRow from "@/components/Tables/MobileRow.vue";
import ReportTable from "@/components/Reports/ReportTable.vue";
import Paginator from "@/components/Paginator.vue";
import "@/assets/scss/TicketsList.scss";
import moment from "moment";
import { useVuelidate } from "@vuelidate/core";
import { required } from "@vuelidate/validators";
import downloadCsv from "vue-json-csv";

export default {
  name: "CVoip",
  components: {
    MyBanner,
    MyHeaderPage,
    downloadCsv,
    MobileRow,
    ReportTable,
    Paginator,
  },
  setup() {
    return { v$: useVuelidate() };
  },
  validations() {
    return {
      dateFrom: { required },
      dateTo: { required },
    };
  },
  data() {
    return {
      viewLoader: false,
      items: [],
      itemFilter: [],
      bills: [],
      voipCsv: [],
      mdlCell3Col: "mdl-cell--3-col",
      mdlCell6Col: "mdl-cell--6-col",
      // Add these for pagination
      currentPage: 1,
      itemsPerPage: 10,
      paginatedItems: 0,
      totalItems: 0,
      // For the CSV export
      isExporting: false,
      // items: [
      //   {
      //       "id": 0,
      //       "data_call": 1704301647,
      //       "from_call": "04211896061",
      //       "to_call": "39199199XXX",
      //       "time_call": "00:06:37",
      //       "price_call": "3.3083",
      //       "price_inc": "0.0",
      //       "destination": "Italy Telecom Italia"
      //   },
      //   {
      //       "id": 0,
      //       "data_call": 1704301647,
      //       "from_call": "04211896061",
      //       "to_call": "444499199XXX",
      //       "time_call": "00:0:37",
      //       "price_call": "4.3083",
      //       "price_inc": "2.0",
      //       "destination": "Italy Fastweb Italia"
      //   }
      // ],
      // itemFilter: [
      //   {
      //       "id": 0,
      //       "data_call": 1704301647,
      //       "from_call": "04211896061",
      //       "to_call": "39199199XXX",
      //       "time_call": "00:06:37",
      //       "price_call": "3.3083",
      //       "price_inc": "0.0",
      //       "destination": "Italy Telecom Italia"
      //   },
      //   {
      //       "id": 0,
      //       "data_call": 1704301647,
      //       "from_call": "04211896061",
      //       "to_call": "444499199XXX",
      //       "time_call": "00:0:37",
      //       "price_call": "4.3083",
      //       "price_inc": "2.0",
      //       "destination": "Italy Fastweb Italia"
      //   }
      // ],
      dateFrom: moment().subtract(1, "years").format("DD-MM-YYYY"),
      dateTo: moment().format("DD-MM-YYYY"),
      bill_id: null,
      he: {
        Accept: "application/json",
        Authorization: "Bearer " + this.$keycloak.idToken,
      },
      searchString: "",
    };
  },
  methods: {
    async getList() {
      const result = await this.v$.$validate();
      if (result) {
        const self = this;

        this.viewLoader = false;

        let par = "";
        if (this.bill_id) {
          par = "&bill_id=" + this.bill_id;
        }

        // Add pagination parameters
        par += "&page=" + this.currentPage;
        if (this.itemsPerPage) {
          par += "&per_page=" + this.itemsPerPage;
        }

        // Add search parameter if exists
        if (this.searchString && this.searchString.trim() !== "") {
          par += "&search=" + this.searchString;
        }

        this.items = [];
        this.itemFilter = [];

        this.axios
          .get(
            window.VUE_APP_MISTRA_URL +
              "front/v1/report-voip/?from=" +
              this.dateFrom +
              "&to=" +
              this.dateTo +
              par,
            { headers: this.he }
          )
          .then((response) => {
            if (response.data.items && response.data.items.length > 0) {
              // Handle the pagination structure
              if (response.data.current_page) {
                // If the API returns paginated data
                this.items = response.data.items;
                this.currentPage = response.data.current_page || 1;
                this.itemsPerPage = response.data.per_page || 10;
                this.totalItems = response.data.total || this.items.length;
                this.paginatedItems = Math.ceil(
                  this.totalItems / this.itemsPerPage
                );
              } else {
                // If the API returns a simple array
                this.items = response.data.items;
                this.totalItems = this.items.length;
                this.paginatedItems = 1;
              }

              this.itemFilter = this.items;
            } else {
              this.bills = response.data.bills;
            }

            this.viewLoader = true;
            this.buildCsv();
          })
          .catch(function (err) {
            // If the call fails, show the standard "no result" state like other reports
            self.items = [];
            self.itemFilter = [];
            self.totalItems = 0;
            self.paginatedItems = 0;
            self.viewLoader = true;
            console.log(err);
          });
      }
    },
    searchByString() {
      // Reset pagination when searching
      this.currentPage = 1;

      // If server-side search is implemented
      if (this.searchString.length >= 3 || this.searchString.length === 0) {
        this.getList();
      } else {
        // Client-side filtering as fallback
        this.itemFilter = [];
        let elm = this.searchString.toLowerCase();
        this.items.forEach((item) => {
          let from_call = item.from_call
            ? item.from_call.toLowerCase().includes(elm)
            : false;
          let to_call = item.to_call
            ? item.to_call.toLowerCase().includes(elm)
            : false;
          let time_call = item.time_call
            ? item.time_call.toLowerCase().includes(elm)
            : false;
          let price_call = item.price_call
            ? item.price_call.toLowerCase().includes(elm)
            : false;
          let price_inc = item.price_inc
            ? item.price_inc.toLowerCase().includes(elm)
            : false;
          let data_call = item.data_call
            ? this.getDate(item.data_call).toLowerCase().includes(elm)
            : false;
          let destination = item.destination
            ? item.destination.toLowerCase().includes(elm)
            : false;
          if (
            from_call ||
            to_call ||
            time_call ||
            price_call ||
            price_inc ||
            data_call ||
            destination
          ) {
            this.itemFilter.push(item);
          }
        });
        this.buildCsv();
      }
    },
    getDate(myTime) {
      return moment.unix(myTime).format("DD-MM-YYYY HH:mm:ss");
    },
    buildCsv() {
      // Object.assign(this.voipCsv, this.itemFilter);

      this.voipCsv = this.itemFilter.map((elem) => ({
        from_call: "'" + elem.from_call + "'",
        to_call: elem.to_call,
        time_call: elem.time_call,
        price_call: elem.price_call,
        price_inc: elem.price_inc,
        data_call: this.getDate(elem.data_call),
        destination: elem.destination,
      }));
    },

    // Methods to handle pagination for the Paginator component
    changePage(page) {
      this.currentPage = page;
      this.getList();
    },

    beforePage() {
      if (this.currentPage > 1) {
        this.currentPage--;
        this.getList();
      }
    },

    nextPage() {
      if (this.currentPage < Math.ceil(this.totalItems / this.itemsPerPage)) {
        this.currentPage++;
        this.getList();
      }
    },
  },
  computed: {
    pagedItems() {
      return this.items || [];
    },
    totalPages() {
      return Math.ceil(this.itemFilter.length / this.itemsPerPage);
    },
  },
  mounted() {
    this.getList();
  },
};
</script>
